import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  ApplicationHostTypeService,
  ReferenceDataConstants,
  ReferenceDataLabels,
  UserSessionService
} from 'rome-library';
import { filter, switchMap } from 'rxjs/operators';
import { LoginService, PopUpService, TokenStore } from '../..';
import { States } from '../../../shared';
import { UserNotificationService } from '../../services/user-notification.service';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'boi-core-dialogs',
  templateUrl: './core-dialogs.component.html'
})
export class CoreDialogsComponent implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataConstants = ReferenceDataConstants;
  public isPopupBlockedDialogOpened = false;
  public isSessionAboutToExpireDialogOpened = false;
  public isGdprDialogOpened = false;
  public isGdprPrivacyNoticeOpened = false;

  constructor(
    private readonly popupService: PopUpService,
    private readonly loginService: LoginService,
    public readonly userSessionService: UserSessionService,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly userService: UserService,
    private readonly tokenStore: TokenStore,
    private readonly router: Router,
    private readonly userNotificationService: UserNotificationService
  ) {}

  public ngOnInit(): void {
    this.popupService
      .popupBlockedObservable()
      .pipe(untilDestroyed(this))
      .subscribe(() => (this.isPopupBlockedDialogOpened = true));

    this.userSessionService.logoutWarning$.pipe(untilDestroyed(this)).subscribe(() => {
      this.isSessionAboutToExpireDialogOpened = true;
    });

    this.userSessionService.logout$
      .pipe(
        switchMap(() => this.loginService.logout(States.SessionClosed)),
        untilDestroyed(this)
      )
      .subscribe(() => {
        this.isSessionAboutToExpireDialogOpened = false;
        this.userSessionService.stopSession();
        this.userNotificationService.stop();
      });

    if (this.applicationHostTypeService.getInterfaceType() === this.referenceDataConstants.BROKER_INTERFACE_TYPE_ID) {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          untilDestroyed(this)
        )
        .subscribe((data: NavigationEnd) => {
          if (data.url.indexOf(States.Login) < 0) {
            const user = this.userService.getUser();
            const isUserAuthenticated = user ? user.IsAuthenticated : false;
            const isPrivacyAccepted = this.tokenStore.getUserContext().AcceptsPrivacyNotes;

            this.isGdprPrivacyNoticeOpened = isUserAuthenticated && !isPrivacyAccepted;
          } else {
            this.isGdprPrivacyNoticeOpened = false;
            this.isGdprDialogOpened = false;
          }
        });
    }
  }

  public openGdprDialog(): void {
    this.isGdprDialogOpened = true;
  }
}
